import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import SharedProviders_0_0 from './extensions/content-cms/providers';
import SharedProviders_1_0 from './extensions/custom-shipping/providers';
import SharedProviders_2_0 from './extensions/order-documents/providers';
import SharedProviders_3_0 from './extensions/newsletter/providers';
import SharedProviders_4_0 from './extensions/tax-overview/providers';


@NgModule({
    imports: [CommonModule, ],
    providers: [...SharedProviders_0_0, ...SharedProviders_1_0, ...SharedProviders_2_0, ...SharedProviders_3_0, ...SharedProviders_4_0],
})
export class SharedExtensionsModule {}
